import { render } from "./BookshelfContent.vue?vue&type=template&id=649b8b41&scoped=true"
import script from "./BookshelfContent.vue?vue&type=script&lang=js"
export * from "./BookshelfContent.vue?vue&type=script&lang=js"

import "./BookshelfContent.vue?vue&type=style&index=0&id=649b8b41&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649b8b41"]])

export default __exports__